import dayjs from 'dayjs';

import { translateStatic } from '../translations';

export const articles = [
  {
    id: 'texted-based-porn-games',
    imgSrc: '/features/previews/texted-based-porn-games-preview.jpg',
    title: 'Best texted based porn games',
    previewText:
      'Choose your own adventures in our wild texted based porn games',
    link: '/texted-based-porn-games',
    date: dayjs('2024-04-21').format('YYYY-MM-DD'),
  },
  {
    id: 'sexy-ai',
    imgSrc: '/features/previews/sexy-ai-preview.jpg',
    title: 'Advanced Sexy AI',
    previewText: 'Craft perfect Sexy AI and enjoy the AI Rolelplay',
    link: '/sexy-ai',
    date: dayjs('2024-03-25').format('YYYY-MM-DD'),
  },
  {
    id: 'erotic-ai',
    imgSrc: '/features/erotic-ai-preview.jpg',
    title: 'Craft your perfect story with Erotic AI',
    previewText: 'Generate AI Erotic story and extend it with spicy images',
    link: '/erotic-ai',
    date: dayjs('2024-03-22').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-waifu',
    imgSrc: '/features/ai-waifu-preview.jpg',
    title: 'Create your AI Waifu',
    previewText:
      'Create your dream AI Waifu and chat with her in our anime chat!',
    link: '/ai-waifu',
    date: dayjs('2024-03-19').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-girl-generator',
    imgSrc: '/features/ai-girl-generator-preview.jpg',
    title: 'The Ultimate AI Girl Generator',
    previewText:
      'Generate your dream girl in seconds with the most advanced AI Girl Generator',
    link: '/ai-girl-generator',
    date: dayjs('2024-03-18').format('YYYY-MM-DD'),
  },
  {
    id: 'nsfw-ai-chat',
    imgSrc: '/features/nsfw-ai-chat-preview.jpg',
    title: translateStatic('blog:articles.nsfw-ai-chat.title'),
    previewText: translateStatic('blog:articles.nsfw-ai-chat.previewText'),
    link: '/nsfw-ai-chat',
    date: dayjs('2024-03-12').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-porn-chat',
    imgSrc: '/features/porn-chat-preview.jpg',
    title: translateStatic('blog:articles.ai-porn-chat.title'),
    previewText: translateStatic('blog:articles.ai-porn-chat.previewText'),
    link: '/ai-porn-chat',
    date: dayjs('2024-03-11').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-chatbot-18',
    imgSrc: '/features/ai-chatbot-18-article/preview.jpg',
    title: translateStatic('blog:articles.ai-chatbot-18.title'),
    previewText: translateStatic('blog:articles.ai-chatbot-18.previewText'),
    link: '/ai-chatbot-18',
    date: dayjs('2024-02-23').format('YYYY-MM-DD'),
  },
  {
    id: 'guide-to-choosing-the-best-nsfw-ai-generator',
    imgSrc:
      '/features/choosing-the-best-nsfw-generator-article/blog-card-preview.jpeg',
    title: translateStatic(
      'blog:articles.guide-to-choosing-the-best-nsfw-ai-generator.title',
    ),
    previewText: translateStatic(
      'blog:articles.guide-to-choosing-the-best-nsfw-ai-generator.previewText',
    ),
    link: '/ultimate-guide-to-choosing-the-best-nsfw-ai-generator-in-2024',
    date: dayjs('2024-02-12').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-girlfriend-chat',
    imgSrc: '/characters/ex-gf.jpg',
    title: translateStatic('blog:articles.article_ai-girlfriend-chat.title'),
    previewText: translateStatic(
      'blog:articles.article_ai-girlfriend-chat.previewText',
    ),
    link: '/ai-girlfriend-chat',
    date: dayjs('2023-01-23').format('YYYY-MM-DD'),
  },
  {
    id: 'ai-sexting',
    imgSrc: '/characters/rebecca.webp',
    title: translateStatic('blog:articles.article_ai-sexting.title'),
    previewText: translateStatic(
      'blog:articles.article_ai-sexting.previewText',
    ),
    link: '/ai-sexting',
    date: dayjs('2023-12-23').format('YYYY-MM-DD'),
  },
  {
    id: 'nsfw-ai-generator',
    imgSrc: '/features/img-gen-preview-main-page.jpg',
    title: translateStatic('blog:articles.article_nsfw-ai-generator.title'),
    previewText: translateStatic(
      'blog:articles.article_nsfw-ai-generator.previewText',
    ),
    link: '/nsfw-ai-generator',
    date: dayjs('2023-12-23').format('YYYY-MM-DD'),
  },
];
